<template>
    <div class="block-header">
        <div class="container">
            <div class="row clearfix">
                <div class="col-lg-6 col-md-12">
                    <div >
                        <h1 class="mb-1 mt-1" v-if="urlOfThis">
                            {{ category[clickedMenu].name }}
                        </h1>
                    </div>
                </div>
            </div>
            <div class="bh_divider"></div>
            <div class="row clearfix" >
                <div class="col-12">
                    <ul class="nav nav-tabs" v-if="urlOfThis">
                        <li class="nav-item" @click="checkUrl()">
                            <a @click="toWorkflowList" :class="{ active: clickedMenu == 0 }" class="nav-link checkLiTop">
                                {{ category[0].name }}
                            </a>
                        </li>

<!--                        <li-->
<!--                            class="nav-item"-->
<!--                            @click="checkUrl()"-->
<!--                        >-->
<!--                            <a-->
<!--                                @click="toRecordList"-->
<!--                                :class="{ active: clickedMenu == 1 }"-->
<!--                                class="nav-link checkLiTop"-->
<!--                            >{{ category[1].name }}-->
<!--                            </a-->
<!--                            >-->
<!--                        </li>-->

                        <li class="nav-item" @click="checkUrl()">
                            <a @click="toTemplateList" :class="{ active: clickedMenu == 2 }" class="nav-link checkLiTop">
                                {{ category[2].name }}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "top",
    data() {
        return {
            clickedMenu : 0,
            nowUrl: "",
            category : [
                {
                    name: "목록",
                    url: "/workflows",
                },
                {
                    name: "기록",
                    url: "/workflows/history",
                },
                {
                    name: "템플릿",
                    url: "/workflows/template",
                },
            ],
        };
    },
    computed: {

        userStore() {
            return this.$store.state.userStore;
        },
        workflowStore() {
            return this.$store.state.workflowStore;
        },
        urlOfThis(){
            console.log(this.$route.fullPath)
            if(this.$route.fullPath.indexOf("/connections") > 0){
                return false;
            } else {
                return true;

            }
        },
    },
    watch: {
        $route() {
            this.checkUrl();
        }
    },
    methods: {
        toWorkflowList(){
            this.clickedMenu = 0;
            this.$router.push({name:'WorkflowPage'})
        },
        toRecordList(){
            this.clickedMenu = 1;
            this.$router.push({name:'HistoryPage'})
        },
        toTemplateList(){
            this.clickedMenu = 2;
            this.$router.push({name:'TemplatePage'})
        },
        checkUrl() {
            console.log(window.location.href)
            this.nowUrl = window.location.href;

            if(this.nowUrl.indexOf("template") > 0){
                this.clickedMenu = 2;
            } else if(this.nowUrl.indexOf("history") > 0){
                this.clickedMenu = 1;

            } else {
                this.clickedMenu = 0;

            }

        }
    },
    created() {
        // this.category = this.$store.state.workflowStore.category

        // console.log(this.category )

        this.checkUrl();
    },
};
</script>
